<template>
  <div class="list_warp">
    <!--当前位置-->
    <div class="w100 breade dif alc">
      <div class="fs14 col333">当前位置：</div>
      <el-breadcrumb separator-class="el-icon-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{ name }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 新闻 -->
    <div class="dif news mrTop20">
      <!--左侧-->
      <div>
        <div class="left">
          <ul>
            <li v-for="(item,index) in left" :key="index" class="dif alc list_item pointer" @click="changeLeft(item.id,index)">
              <!--<img class="bra bgcb" style="width: 4rem;height: 4rem;">-->
              <div class="one_overflow list_title" style="width: 24rem;"
                   :class="{'active':current===index}"
              >{{item.name}}</div>
            </li>
          </ul>
        </div>
      </div>
      <!--右侧-->
      <div class="right">
        <!--右侧列表-->
        <ul>
          <li class="one_overflow list col101010 fs16 mrBtm10 pointer" @click="goDetail(item.id)"
              v-for="(item,index) in right" :key="index">{{item.title}}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "list",
  data() {
    return {
      id: '',//大分类id
      left: [],//左侧分类列表
      right: [],//右侧列表
      current: 0,
      name: '',//当前位置
    }
  },
  watch: {
    "$route.query": function (newValue) {
      this.name = newValue.name
      this.getLeftCate(newValue.id)
    }
  },
  methods: {
    changeLeft(id,index) {
      this.current = index
      this.getRightList(id)
    },
    goDetail(id) { //文章详情
      let routeUrl = this.$router.resolve({
        path: '/article',
        query: {
          id: id
        }
      })
      window.open(routeUrl .href, '_blank');
    },
    getLeftCate(id) {
      this.$axios("POST","/index/cms_channel_list",{id})
      .then(res => {
        if(res.code===1) {
          this.left = res.data
          this.getRightList(res.data[0].id)
        }
      })
    },
    getRightList(id) { //获取右侧的列表
      this.$axios("POST","/index/cms_archives",{id},'加载中')
      .then(res => {
        if(res.code===1) {
          this.right = res.data
        }
      })
    },
  },
  created() {
    this.id = this.$route.query.id
    this.name = this.$route.query.name
    this.getLeftCate(this.id)
  }
}
</script>

<style scoped>
  .list_warp{
    padding-bottom: 12rem;
  }
  .breade{
    height: 4rem;
    width: 100%;
    background: #E5FFFA ;
    box-sizing: border-box;
    padding-left: 3rem;
  }
  .left{
    width: 33rem;
    border-radius: 1rem;
    box-shadow: 0px 0px 0.6rem 0px rgba(0, 0, 0, 0.4);
    box-sizing: border-box;
    padding: 1.6rem;
  }
  .right{
    margin-left: 7rem;
    width: 60%;
  }
  .list{
    transition: all 0.1s;
    box-sizing: border-box;
    margin-bottom: 2rem;
  }
  .list:hover{
    text-decoration: underline;
    color: #4eac4e;
  }
  .list_item{
    margin-bottom: 2rem;
  }
  .list_item:nth-last-child(1) {
    margin-bottom: 0;
  }
  .list_title{
    margin-left: 1.6rem;
    font-size: 1.6rem;
    color: #000;
  }
  .list_title.active{
    color: #4eac4e;
  }
</style>